import React, { type FC, type ReactNode } from 'react';
import Heading from '@atlaskit/heading';
import { Flex, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import HelpPanelButton from '@atlassian/jira-help-panel-button';
import { type MessageDescriptor, useIntl } from '@atlassian/jira-intl';
import { Link } from '@atlassian/react-resource-router';

export const DetailSection: FC<{
	headerMessage: MessageDescriptor;
	subheaderMessage: MessageDescriptor;
	buttonMessage: MessageDescriptor;
	articleId: string;
	fallbackLink: string;
	image: ReactNode;
}> = ({ headerMessage, subheaderMessage, buttonMessage, articleId, fallbackLink, image }) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.800" spread="space-between" alignInline="start" alignBlock="center">
			<Stack alignBlock="start" alignInline="start" space="space.100" xcss={textStyles}>
				<Heading size="small" as="h3">
					{formatMessage(headerMessage)}
				</Heading>
				<Text as="span">{formatMessage(subheaderMessage)}</Text>
				<HelpPanelButton
					articleId={articleId}
					appearance="link"
					spacing="none"
					fallbackComponent={
						<Link target="_blank" rel="noopener noreferrer" href={fallbackLink}>
							{formatMessage(buttonMessage)}
						</Link>
					}
				>
					{formatMessage(buttonMessage)}
				</HelpPanelButton>
			</Stack>
			<Flex justifyContent="end" xcss={imageStyles}>
				{image}
			</Flex>
		</Inline>
	);
};

const textStyles = xcss({
	maxWidth: '440px',
	width: '100%',
});

const imageStyles = xcss({
	maxWidth: '530px',
	width: '100%',
});
